import React, { useEffect, useRef, useState } from "react";
import { useI18n } from "../i18n/I18nProvider";

const LOCALES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "ar", label: "العربية" },
];

function LanguageSwitcher() {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const { locale, setLocale, t } = useI18n();

  useEffect(() => {
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  const current = LOCALES.find((l) => l.code === locale) || LOCALES[0];

  return (
    <div className="lang-dropdown" ref={wrapRef}>
      <button
        type="button"
        className="lang-dropdown__trigger"
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={t("lang.label")}
        onClick={() => setOpen((v) => !v)}
      >
        <img
          src="/images/lang-icon.png"
          alt=""
          className="lang-dropdown__icon"
          width={22}
          height={22}
        />
        <span className="lang-dropdown__current">{current.label}</span>
        <span className="lang-dropdown__chevron" aria-hidden>
          ▾
        </span>
      </button>
      {open && (
        <ul className="lang-dropdown__menu" role="listbox">
          {LOCALES.map(({ code, label }) => (
            <li key={code} role="none">
              <button
                type="button"
                role="option"
                aria-selected={locale === code}
                className={
                  "lang-dropdown__option" +
                  (locale === code ? " lang-dropdown__option--active" : "")
                }
                onClick={() => {
                  setLocale(code);
                  setOpen(false);
                }}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LanguageSwitcher;
